import request from '@/utils/request'

export function getApproveInfoList(data) {
  return request.post('/approve-info/list', data)
}

export function addApproveInfo(data) {
  return request.post('/approve-info/add', data)
}

export function modifyApproveInfo(data) {
  return request.post('/approve-info/modify', data)
}

export function deleteApproveInfo(data) {
  return request.post('/approve-info/delete', data)
}

export function uploadFileOfApproveInfo(data) {
  return request.post('/approve-info/upload-file', data)
}

export function deleteFileOfApproveInfo(data) {
  return request.post('/approve-info/delete-file', data)
}

export function approveInfo(data) {
  return request.post('/approve-info/approve', data)
}



// WEBPACK FOOTER //
// ./src/api/settings/approve-info.js